export default {
  layerStyles: {
    kioskBody: {
      bg: "#460D17",
      color: "white",
      overflow: "hidden",
    },
    kioskBarcodeLayout: {
      display: "grid",
      gridColumnGap: "0",
      gridTemplateColumns: {
        base: "1fr",
        sm: "1fr min-content 1fr",
      },
      gridTemplateRows: {
        base: "1fr 2fr",
        sm: "1fr",
      },
      m: "0 auto",
      maxW: "1440px",
      w: "full",
      h: "full",
      Login: {
        p: {
          base: 4,
          sm: 8,
        },
        gridRow: {
          base: 2,
          sm: "auto",
        },
      },
      Logo: {
        p: {
          base: 4,
          sm: 8,
        },
        gridRow: {
          base: 1,
          sm: "auto",
        },
      },
    },
    kioskSidebarLayout: {
      height: "calc(100vh)",
      width: "full",
      display: "grid",
      gridColumnGap: "0",
      gridTemplateColumns: {
        base: "minmax(220px, 1fr) minmax(10px, 3fr)",
        md: "minmax(220px, 1fr) minmax(10px, 3fr)",
      },
      gridTemplateRows: "min-content min-content 1fr min-content",
      gridTemplateAreas: {
        base: "'head head head' 'sidebar content content' 'sidebar content content' 'sidebar content content'",
        md: "'head head head' 'sidebar content content' 'sidebar content content' 'sidebar content content'",
      },
    },
    kioskHeader: {
      gridArea: "head",
      justifyContent: "space-between",
      padding: "10px 20px",
    },
    kioskSidebar: {
      gridArea: "sidebar",
      padding: "10px 20px",
      display: "grid",
      gridTemplateRows: "min-content max-content min-content",
      gridTemplateAreas: "'avatar' 'name' 'appointments'",
      background: "rgba(0,0,0,0.3)",
    },
    kioskMain: {
      py: "10px",
      // display: "grid",
      overflow: "hidden",
      overflowY: "hidden",
      gridArea: "content",
      gridTemplateRows: "auto",
      gridTemplateAreas: "'content'",
      mr: "20px",
    },
    kioskGridWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    kioskGrid: {
      gridGap: "12px",
      display: "grid",
      width: "100%",
      gridAutoRows: "1fr",
      gridTemplateColumns: {
        base: "repeat(2, 1fr)",
        sm: "repeat(3, 1fr)",
        lg: "repeat(4, 1fr)",
        xl: "repeat(5, 1fr)",
        "2xl": "repeat(6, 1fr)",
      },
      w: "full",
    },
    kioskGridItem: {
      borderRadius: "0",
      h: "full",
      w: "full",
      overflow: "hidden",
      p: "2px",
      button: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
      },
      Name: {
        color: "inherit",
        whiteSpace: "break-spaces",
        noOfLines: 2,
      },
      Button: {
        h: "full",
        w: "full",
        py: 0,
        _pressed: {
          boxShadow: "none",
          bg: "red",
          color: "brand.secondary.300",
        },
      },
      Icon: {
        bg: "rgba(0,0,0,0.2)",
        p: 4,
        m: 2,
        borderRadius: "full",
      },
      Text: {
        overflow: "hidden",
        h: 20,
        w: 20,
        borderRadius: "full",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        Text: {
          fontSize: "4xl",
        },
      },
    },
  },
};
